import { BaseMarkerRenderer } from '../base/baseMarkerRenderer'
import { PolygonMarker } from './polygonMarker'
import { MarkerModes } from '../../types'
import { arePointsWithinDistance } from '../../helperFunctions'
import type p5 from 'p5'
import type { Segment } from '../../types'

function drawSegment(gfx: p5, segment: Segment) {
  gfx.line(segment.start.x, segment.start.y, segment.end.x, segment.end.y)
}

class PolygonMarkerRenderer extends BaseMarkerRenderer<PolygonMarker> {
  declare marker: PolygonMarker

  constructor(marker: PolygonMarker) {
    super(marker)
  }

  renderHandles(): void {
    if (this.marker.state.mode === MarkerModes.Edit) {
      const state = this.marker.state
      const handles = state.handles
      const addVertextHandle = state.addVertexHandle
      handles.forEach((handle) => handle.render())
      if (addVertextHandle) this.marker.state.addVertexHandle.render()
    }
  }

  renderMarker(): void {
    const marker = this.marker
    const gfx = this.marker.p
    const controller = this.marker.controller
    const state = marker.state
    const isDashed = marker.state.isDashed
    const vertices = state.vertices

    //Logic to draw temp segment for vertex placement preview.
    if (state.mode === MarkerModes.Create && vertices.length > 0) {
      this.marker.p.stroke(this.marker.state.guidelineStrokeColor)
      const firstVertex = vertices[0]
      const lastVertex = vertices[vertices.length - 1]
      const currentMousePosition = {
        x: controller.mouseCoordinateX,
        y: controller.mouseCoordinateY,
      }
      const isNewPointCloseToFirst = arePointsWithinDistance(
        currentMousePosition,
        firstVertex.position,
        this.marker.state.closingClickRadius
      )

      if (isNewPointCloseToFirst && vertices.length > 2) {
        drawSegment(gfx, { start: lastVertex.position, end: firstVertex.position })
      } else {
        drawSegment(gfx, {
          start: lastVertex.position,
          end: currentMousePosition,
        })
      }
    }

    this.marker.p.stroke(this.marker.state.strokeColor)

    state.edges.forEach((edge) => {
      edge.render(gfx, {
        isDashed: isDashed,
        dashLength: state.dashLength,
        dashSpaceLength: state.dashSpaceLength,
      })
    })
  }
}

export { PolygonMarkerRenderer }
